import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const Planner = () => {
    return (_jsx(_Fragment, { children: _jsx("div", { style: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginRight: 'auto',
                marginLeft: '0rem',
                marginTop: '2rem',
                marginBottom: '2rem'
            }, children: _jsx("h4", { children: "Planner" }) }) }));
};
export default Planner;
